import _ from 'lodash'

import React, { useMemo } from 'react'
import Tag from './Tag'

export const threeDSResponse = {
	passed: 'PASSED',
	didNotPass: 'DID_NOT_PASS',
	skipped: 'SKIPPED',
	failed: 'FAILED',
	notPerformed: 'NOT_PERFORMED',
}

export default function ThreeDSTag(props) {
	const { status, big, block } = props

	const sentiment = useMemo(() => {
		switch (status) {
			case threeDSResponse.passed:
				return 'positive'

			case threeDSResponse.failed:
			case threeDSResponse.didNotPass:
				return 'negative'

			case threeDSResponse.skipped:
			case threeDSResponse.notPerformed:
				return 'neutral'
			default:
				return 'neutral'
		}
	}, [status])

	const text = _.startCase(_.toLower(status))

	return <Tag size={big ? 'big' : 'small'} sentiment={sentiment} text={text} block={block} styl='regularNoBorder' />
}
